import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../../types/layouts.esm.js';

function mergeLayouts(serviceLayouts, defaultLayouts) {
  var defaultIsSelected = !serviceLayouts.some(function (l) {
    return l.selected;
  });
  var predefinedIsSelected = serviceLayouts.find(function (l) {
    return l.selected && l.type === LayoutType.Predefined;
  });
  var defaultLayout = defaultLayouts.filter(function (l) {
    return l.type === LayoutType.Default;
  }).map(function (l) {
    return _objectSpread2(_objectSpread2({}, l), {}, {
      selected: !!defaultIsSelected
    });
  });
  var predefinedLayout = defaultLayouts.filter(function (l) {
    return l.type === LayoutType.Predefined;
  }).map(function (l) {
    return predefinedIsSelected && l.label === (predefinedIsSelected === null || predefinedIsSelected === void 0 ? void 0 : predefinedIsSelected.label) ? _objectSpread2(_objectSpread2({}, l), {}, {
      selected: true,
      id: predefinedIsSelected.id
    }) : l;
  });
  var customLayouts = serviceLayouts.filter(function (l) {
    return l.type === LayoutType.Custom;
  });
  var savedLayouts = serviceLayouts.filter(function (l) {
    return l.type === LayoutType.Saved;
  });
  return [].concat(_toConsumableArray(defaultLayout), _toConsumableArray(customLayouts), _toConsumableArray(predefinedLayout), _toConsumableArray(savedLayouts));
}

export { mergeLayouts };
//# sourceMappingURL=merge-layouts.esm.js.map
